import { Component, OnInit, Input, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, FormControl } from '@angular/forms';
import { DialogCloseResult, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { DataStateChangeEvent, DetailExpandEvent, FilterService, GridComponent, GridDataResult, PageChangeEvent, RemoveEvent } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor, filterBy, State, process, FilterDescriptor } from '@progress/kendo-data-query';
import { FormCanDeactivate } from 'src/app/form-can-deactivate/form-can-deactivate.component';
import { IDeliverableSave } from 'src/app/interface/IDeliverables';
import { IKeyPairValue } from 'src/app/interface/IKeyValuePair';
import { Common } from 'src/app/common/common';
import { IDocument } from 'src/app/interface/IDocument';
import { DeliverablesService } from 'src/app/service/deliverables/deliverables.service';
import { CommonService } from 'src/app/service/common/common.service';
import { ClearEvent, FileRestrictions, SelectEvent } from '@progress/kendo-angular-upload';
import { CommonUtil } from 'src/app/common/common.util';
import { NotificationService } from '@progress/kendo-angular-notification';
import * as $ from 'jquery';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';

type AOA = any[][];

const flatten = filter => {
  const filters = (filter || {}).filters;
  if (filters) {
    return filters.reduce((acc, curr) => acc.concat(curr.filters ? flatten(curr) : [curr]), []);
  }
  return [];
};

const distinctTitle = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.title === x.title) === idx);

const distinctDescription = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.description === x.description) === idx);

const distinctAgreementYear = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.agreementYear === x.agreementYear) === idx);

const distinctDeliverableType = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.typeName === x.typeName) === idx);

const distinctDelPeriodName = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.deliverablePeriodName === x.deliverablePeriodName) === idx);

const distinctDelDescName = data => data.map(x => x)
  .filter((x, idx, xs) => xs.findIndex(y => y.description === x.description) === idx);

@Component({
  selector: 'app-deliverable-entry',
  templateUrl: './deliverable-entry.component.html',
  styleUrls: ['./deliverable-entry.component.scss']
})

export class DeliverableEntryComponent extends FormCanDeactivate implements OnInit, OnDestroy {
  @Input() agreementId: string;
  @Input() awardNumber: string;
  @Input() awardNickName: string;
  @Input() awardTitle: string;
  @Input() awardStatus: boolean;
  @Input() roles: string;

  @ViewChild('ngFormDirtyCheck') ngFormDirtyCheck: NgForm; // for dirty check
  @ViewChild('deliverableGrid') deliverableGrid: GridComponent;
  @ViewChild('deliverableDetailGrid') deliverableDetailGrid: GridComponent;
  mimeMapping: Map<string, string> = new Map([['csv', 'text/csv'],
  ['jpg', 'image/jpeg'],
  ['jpeg', 'image/jpeg'],
  ['png', 'image/png'],
  ['pdf', 'application/pdf'],
  ['doc', 'application/msword'],
  ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  ['xls', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  ['ppt', 'application/vnd.ms-powerpoint'],
  ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
  ['rtf', 'application/rtf'],
  ['csv', 'text/csv'],
  ['htm', 'text/html'],
  ['html', 'text/html'],
  ['zip', 'application/zip'],
  ['msg', 'application/vnd.ms-outlook']]);

  constructor(private dialogService: DialogService, public deliverablesService: DeliverablesService,
              private commonService: CommonService, private notificationService: NotificationService,
              private formBuilder?: FormBuilder) {
              super();
            }

  public ngForm: FormGroup;
  public dialogRef: DialogRef;
  public defaultGuid: string = '00000000-0000-0000-0000-000000000000';
  public notificationList: IKeyPairValue[] = [];
  public notificationOriginalList: IKeyPairValue[] = [];
  public deliverableTypeList: IKeyPairValue[] = [];
  public deliverableTypeOriginalList: IKeyPairValue[] = [];
  public deliverableEntryForm: FormGroup;
  public deliverableListGrid: GridDataResult;
  public deliverableList: IDeliverableSave[] = [];
  private editedRowIndex: number;
  private counter: number = this.deliverableList.length;
  public deleteDeliverableIds: any[] = [];
  public saveFlag: boolean = false;
  public inValidDeliverableType: boolean = false;
  public validContactSave: boolean = false;
  public agreementYear: any = null;
  public isReadOnlyPage: boolean = false;
  public agreementYears: any;
  // Deliverable Details
  public deliverableDetailForm: FormGroup;
  public deliverableDetailsGrid: GridDataResult;
  public deliverableDetailList: IDeliverableSave[] = [];
  public inValidDeliverableDetail: boolean = false;
  public saveDetailFlag: boolean = false;
  public validDetailsSave: boolean = false;
  public deleteDeliverableDetailIds: IDocument[] = [];
  public deliverableDetailId: string;
  // Document
  public documentFormGroup: FormGroup;
  public uploadFile: any = '';
  public newUploadFileList: IDocument[] = [];
  public fileName: string = '';
  public originalDocumentTypeList: IKeyPairValue[] = [];
  public documentTypeList: IKeyPairValue[] = [];
  public deliverablePeriodList: IDeliverableSave[] = [];
  public deliverablePeriodYearList: any[] = [];
  public orginalDeliverablePeriodValueList: IKeyPairValue[] = [];
  public deliverablePeriodValueList: IKeyPairValue[] = [];
  public deliverablePeriodIdChange: any;
  public agreementYearList: any[] = [];
  public documentUri: any;
  public selectedDataItem: any;
  public selectedRowIndex: number;
  public disabledUploadButton: boolean = false;
  public isDocumentTypeSelected: boolean = true;
  public isDocumentSelected: boolean = true;
  public validateFile: boolean = true;
  public isValidForm: boolean = true;
  public enableAwardYear: boolean = false;
  public enableAgreementYear: boolean = false;
  public isExistingDocumentName: boolean = false;
  public uploadRestrictions: FileRestrictions = {
    allowedExtensions: ['.jpg', '.jpeg', '.doc', '.docx', '.png', '.pdf', '.txt', '.xls', '.xlsx', '.msg', '.ppt', '.pptx', '.rtf', '.csv', '.zip', '.htm', '.html']
  };
  public disabledSelectFileButton: boolean = false;
  public moduleName = 'Deliverables';
  public isDeleteFlag: boolean = false;
  public deliverablePeriod = '';
  public deliverablePeriodvalue = '';
  public isEditDocumentDialug: boolean = false;
  public fileExtension: any;
  public orgFileName: any;
  public SpDocumentName: any;
  // Pagination
  public pageSize = 10;
  public skip = 0;
  public typedg: 'numeric' | 'input' = 'numeric';
  public buttonCount = 5;
  public info = true;
  public pageSizes = true;
  public previousNext = true;
  public text: string = '';
  public enteredSearchText: string = '';
  public reqstate: State = {
    skip: 0,
    take: 10
  };
  public filter?: CompositeFilterDescriptor;
  public filteredData: any = [];
  public deliverableId: string;
  public uploadFileList: IDocument[] = [];
  public deleteDocuments: IDocument[] = [];
  private intervaltime;
  public isEnableDocumentDialug: boolean = false;
  public disableAddDocButton: boolean = false;
  // column filter
  public categoryFilter: any[] = [];
  public titleValue: any[] = [];
  public agreementYearValue: any[] = [];
  public deliverableTypeValue: any[] = [];
  public deliverablePeriodName: any[] = [];
  public deliverableDesc: any[] = [];
  // Preview
  public dialogPreviewRef: DialogRef;
  public data: any;
  public headData: any;
  public isEnableJPG: boolean = false;
  public isEnablemsg: boolean = false;
  public isEnableXLXS: boolean = false;
  public isEnableTXT: boolean = false;
  public isEnablePDF: boolean = false;
  public isEnableDOCX: boolean = false;
  public url: any;
  public documentURI: '';
  public enablePreviewDataItem: any;

  pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
  }

  filterChange(filter: CompositeFilterDescriptor): void {
    this.filter = filter;
    const filterData = filterBy(this.deliverableList, filter);
    this.deliverableListGrid = process(filterData, this.reqstate);
  }

  detailsFilterChange(filter: CompositeFilterDescriptor, delId: string): void {
    this.deliverableList.forEach(element => {
      if (element.id === delId) {
        element.detailFilter = filter;
        const filterData = filterBy(this.deliverableDetailList, filter);
        element.detailList = process(filterData, this.reqstate);
      }
    });
  }

  public detailsDataStateChange(state: DataStateChangeEvent, delId: string): void {
    this.reqstate = state;
    this.deliverableList.forEach(element => {
      if (element.id === delId) {
        element.detailRecord = process(this.deliverableDetailList, this.reqstate);
      }
    });
  }

  dataStateChange(state: DataStateChangeEvent): void {
    this.reqstate = state;
    this.deliverableListGrid = process(this.deliverableList, this.reqstate);
  }

  ngOnInit() {
    this.initializeDeliverableFormControls();
    this.getDeliverablesType();
    this.getDeliverablePeriod();
    this.agreementYears = localStorage.getItem('awardAgreementYear');
    this.getAgreementYear();
    if (this.agreementId) {
      if (this.awardStatus === true) {
        this.isReadOnlyPage = true;
      } else {
        this.isReadOnlyPage = false;
      }
      if (this.roles === 'Observer') {
        this.disableAddDocButton = true;
      } else {
        this.disableAddDocButton = false;
      }
      this.getDeliverablesInformation();
    }
    if (+environment.isAutoSaveEnableFlag === 1) {
      this.autoSave();
    }
  }

  // initialize Deliverable Form Controls
  initializeDeliverableFormControls() {
    this.deliverableEntryForm = this.formBuilder.group({
      title: new FormControl(''),
      agreementYearValue: new FormControl(''),
      deliverableType: new FormControl('')
    });

    this.deliverableDetailForm = this.formBuilder.group({
      deliverableType: new FormControl(''),
      deliverablePeriod: new FormControl(''),
      description: new FormControl(''),
      dueDate: new FormControl(''),
      completedDate: new FormControl('')
    });

    this.documentFormGroup = this.formBuilder.group({
      displayFileName: new FormControl(),
      documentType: new FormControl(),
      deliverablePeriod: new FormControl(),
    });
  }

  // To get Notification Frequency
  getNotificationFrequency() {
    this.commonService.getNotificationFrequency().subscribe((response) => {
      this.notificationOriginalList = response;
      this.notificationList = this.notificationOriginalList.slice();
    });
  }

  // To get Deliverables Type
  getDeliverablesType() {
    this.commonService.getDeliverablesType().subscribe((response) => {
      this.deliverableTypeOriginalList = response;
      this.deliverableTypeList = this.deliverableTypeOriginalList.slice();
    });
  }

  // To get Deliverables Information
  public getDeliverablesInformation() {
    Common.loader('show');
    this.deliverablesService.getDeliverableInformation(this.agreementId, this.agreementYear).subscribe((response) => {
      if (response.Deliverable && response.Deliverable.length > 0) {
        this.deliverableList = response.Deliverable;
        this.deliverableList.forEach((element: any) => {
          element.typeName = element.deliverableTypeName;
          element.frequencyName = element.notificationFrequencyName;
        });
        this.skip = 0;
        this.deliverableListGrid = {
          data: this.deliverableList.slice(this.skip, this.skip + this.pageSize),
          total: this.deliverableList.length
        };
        this.titleValue = distinctTitle(this.deliverableList.filter((x) => x.title !== ''));
        this.agreementYearValue = distinctAgreementYear(this.deliverableList.filter((x) => x.agreementYear !== null));
        this.deliverableTypeValue = distinctDeliverableType(this.deliverableList.filter((x) => x.typeName !== ''));
      } else {
        this.deliverableListGrid = null;
      }
      Common.loader('hide');
    });
  }

  // To get Document type
  getDocumentType() {
    this.commonService.getDocumentType().subscribe((response) => {
      this.originalDocumentTypeList = response;
      this.documentTypeList = this.originalDocumentTypeList.slice();
    });
  }

  // To get Document period
  getDeliverablePeriod() {
    this.deliverablesService.getDeliverablePeriod().subscribe((response) => {
      this.deliverablePeriodList = response;
    });
  }

  // To set agreement year
  getAgreementYear() {
    this.agreementYearList = [];
    if (this.agreementYears > 0) {
      this.enableAgreementYear = true;
      for (let i = 1; i <= this.agreementYears; i++) {
        this.agreementYearList.push(i);
      }
    }
  }

  // To get Document Information
  getDocumentDetails(deliverableDetailId: string) {
    this.uploadFileList = [];
    const getDocumentList: IDocument = {};
    getDocumentList.deliverableDetailId = deliverableDetailId;
    getDocumentList.agreementId = null;
    getDocumentList.deliverableId = null;
    getDocumentList.agreementPriorApprovalId = null;
    getDocumentList.financialInformationId = null;
    getDocumentList.agreementNoteId = null;
    getDocumentList.isAllDocument = false;
    this.commonService.getDocument(getDocumentList).subscribe((response) => {
      if (response !== undefined && response.Documents.length > 0) {
        response.Documents.forEach(res => {
          this.deliverableDetailList.forEach(ele => {
            if (ele.id === res.deliverableDetailId) {
              this.uploadFileList.push(res);
              ele.uploadFileList = this.uploadFileList;
            }
          });
        });
      }
    });
  }

  // agreement year Filter change
  agreementYearFilterChange(data: any) {
    this.agreementYear = undefined;
    this.deliverableList.forEach((item, idx) => {
      this.deliverableGrid.collapseRow(idx);
    });
    if (data) {
      this.agreementYear = data;
    } else {
      this.agreementYear = null;
    }
    this.getDeliverablesInformation();
  }

  // deliverable grid start
  public addHandler({ sender }, parentGrid) {
    this.agreementYear = '';
    this.deliverableTypeList.forEach((item, idx) => {
      parentGrid.collapseRow(idx);
    });
    this.closeEditor(sender);
    this.initializeDeliverableFormControls();
    sender.addRow(this.deliverableEntryForm);
  }

  public editHandler({ sender, rowIndex, dataItem }, parentGrid) {
    this.deliverableTypeList.forEach((item, idx) => {
      parentGrid.collapseRow(idx);
    });
    this.closeEditor(sender);
    this.deliverableEntryForm = this.formBuilder.group({
      title: dataItem.title,
      agreementYearValue: dataItem.agreementYear,
      deliverableType: dataItem.deliverableTypeId,
    });
    this.editedRowIndex = rowIndex;
    sender.editRow(rowIndex, this.deliverableEntryForm);
  }

  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex);
  }

  public saveHandler({ sender, rowIndex, formGroup, isNew, dataItem }, agreementId: any, parentGrid) {
    this.filter = null;
    this.deliverableTypeList.forEach((item, idx) => {
      parentGrid.collapseRow(idx);
    });
    this.saveFlag = this.validateDeliverableSave(formGroup);
    if (this.saveFlag) {
      const tempData: IDeliverableSave = {};
      const selectedDeliverableType = this.deliverableTypeList.find((el) =>
        el.deliverableTypeId === formGroup.controls.deliverableType.value);
      tempData.title = formGroup.controls.title.value;
      tempData.agreementYear = formGroup.controls.agreementYearValue.value ? formGroup.controls.agreementYearValue.value : null;
      tempData.typeName = selectedDeliverableType.typeName;
      tempData.deliverableTypeId = selectedDeliverableType.deliverableTypeId;
      if (isNew) {
        tempData.id = this.defaultGuid;
        tempData.agreementId = agreementId;
        tempData.rowId = this.counter++;
        this.deliverableList.push(tempData);
        this.deliverableListGrid = process(this.deliverableList, this.reqstate);
        this.saveDeliverables();
      } else {
        if (dataItem.id) {
          Object.assign(
            this.deliverableList.find(({ id }) => id === dataItem.id),
            tempData
          );
        } else {
          Object.assign(
            this.deliverableList.find(({ rowId }) => rowId === rowIndex),
            tempData
          );
        }
        this.deliverableListGrid = process(this.deliverableList, this.reqstate);
        this.saveDeliverables();
      }
      const element: HTMLElement = document.getElementById('submitBtn') as HTMLElement;
      element.click();
      this.deliverableEntryForm.reset();
      sender.closeRow(rowIndex);
    } else {
      this.mandatoryError();
    }
    this.show();
  }

  mandatoryError() {
    this.dialogRef = this.dialogService.open({
      title: 'Information',
      content: 'Please select Deliverable Type',
      actions: [
        { text: 'Ok', primary: true }
      ],
      width: 400,
    });
  }

  public removeHandler({ dataItem }, parentGrid): void {
    this.deleteDeliverableIds = [];
    this.dialogRef = this.dialogService.open({
      title: 'Please Confirm',
      content: 'Deliverable "' + dataItem.title + '" and all the associated document(s) will be deleted. Do you want to continue?',
      actions: [
        { text: 'Yes', primary: true },
        { text: 'No' }],
      width: 400,
    });
    this.dialogRef.result.subscribe((rs: any) => {
      if (rs.text && rs.text === 'Yes') {
        this.filter = null;
        if (dataItem.id) {
          this.deliverableTypeList.forEach((item, idx) => {
            parentGrid.collapseRow(idx);
          });
          Common.loader('show');
          this.deleteDeliverableIds = dataItem.id;
          this.deleteDeliverables();
        }
      }
    });
  }

  routeAfterChange() {
    const element: HTMLElement = document.getElementById('submitBtn') as HTMLElement;
    element.click();
    this.notificationService.show({
      content: 'Deleted Successfully.',
      position: { horizontal: 'center', vertical: 'bottom' },
      animation: { type: 'fade', duration: 500 },
      type: { style: 'success', icon: true },
      hideAfter: 1000,
    });
    this.agreementYear = '';
    this.ngOnInit();
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
  }
  // deliverable grid end

  // Deliverable Detail grid Start
  public addDetailHandler({ sender }, childGrid, rowIndex) {
    this.deliverablePeriodList.forEach((item, idx) => {
      childGrid.collapseRow(idx);
    });
    this.closeDetailEditor(sender);
    this.deliverableDetailForm = this.formBuilder.group({
      deliverablePeriod: new FormControl(''),
      description: new FormControl(''),
      dueDate: new FormControl(''),
      completedDate: new FormControl('')
    });
    this.deliverableId = rowIndex.id;
    sender.addRow(this.deliverableDetailForm);
  }

  public editDetailHandler({ sender, rowIndex, dataItem }, childGrid) {
    this.deliverablePeriodList.forEach((item, idx) => {
      childGrid.collapseRow(idx);
    });
    this.closeDetailEditor(sender);
    this.deliverableId = dataItem.deliverableId;
    if (dataItem.deliverablePeriodId) {
      this.getDeliverablePeriodValue(dataItem.deliverablePeriodId);
    }
    if (this.deliverableId) {
      this.getDeliverableDetails(this.deliverableId);
    }
    this.deliverableDetailForm = this.formBuilder.group({
      deliverablePeriod: dataItem.deliverablePeriodId,
      description: dataItem.description,
      dueDate: dataItem.dueDate ? new Date(dataItem.dueDate) : null,
      completedDate: dataItem.completedDate ? new Date(dataItem.completedDate) : null,
    });
    this.editedRowIndex = rowIndex;
    sender.editRow(rowIndex, this.deliverableDetailForm);
  }

  public cancelDetailHandler({ sender, rowIndex }) {
    this.closeDetailEditor(sender, rowIndex);
  }

  public saveDetailHandler({ sender, rowIndex, formGroup, isNew, dataItem }, childGrid) {
    this.deliverablePeriodList.forEach((item, idx) => {
      childGrid.collapseRow(idx);
    });
    this.saveDetailFlag = this.validateDeliverableDetailsSave(formGroup);
    if (this.saveDetailFlag) {
      const tempData: IDeliverableSave = {};
      const dueDate = formGroup.controls.dueDate.value;
      const completedDate = formGroup.controls.completedDate.value;
      const selectedDeliverablePeriod = this.deliverablePeriodList.find((el) =>
        el.deliverablePeriodId === formGroup.controls.deliverablePeriod.value);
      tempData.deliverablePeriodId = selectedDeliverablePeriod.deliverablePeriodId;
      tempData.description = formGroup.controls.description.value;
      tempData.dueDate = dueDate ? dueDate : null;
      tempData.completedDate = completedDate ? completedDate : null;
      if (isNew) {
        tempData.id = this.defaultGuid;
        tempData.deliverableId = this.deliverableId;
        tempData.rowId = this.counter++;
        this.deliverableDetailList = [];
        this.deliverableDetailList.push(tempData);
        this.saveDeliverableDetails();
      } else {
        if (dataItem.id) {
          Object.assign(
            this.deliverableDetailList.find(({ id }) => id === dataItem.id),
            tempData
          );
        } else {
          Object.assign(
            this.deliverableDetailList.find(({ rowId }) => rowId === rowIndex),
            tempData
          );
        }
        this.saveDeliverableDetails();
      }
      const element: HTMLElement = document.getElementById('submitBtn') as HTMLElement;
      element.click();
      this.deliverableDetailForm.reset();
      sender.closeRow(rowIndex);
    } else {
      this.dialogRef = this.dialogService.open({
        title: 'Information',
        content: 'Please select Deliverable Period',
        actions: [
          { text: 'Ok', primary: true }
        ],
        width: 400,
      });
    }
    this.detailsShow();
  }

  public detailsShow(): void {
    if (this.saveDetailFlag) {
      this.notificationService.show({
        content: 'This has been saved.',
        position: { horizontal: 'center', vertical: 'bottom' },
        animation: { type: 'fade', duration: 500 },
        type: { style: 'success', icon: true },
        hideAfter: 1000,
      });
    }
  }

  public removeDetailHandler({ dataItem }, childGrid): void {
    this.deleteDeliverableDetailIds = [];
    this.deleteDocuments = [];
    this.dialogRef = this.dialogService.open({
      title: 'Please Confirm',
      content: 'Are you sure, do you want to delete it?',
      actions: [
        { text: 'Yes', primary: true },
        { text: 'No' }],
      width: 400,
    });
    this.dialogRef.result.subscribe((rs: any) => {
      if (rs.text && rs.text === 'Yes') {
        if (dataItem.id) {
          this.deliverablePeriodList.forEach((item, idx) => {
            childGrid.collapseRow(idx);
          });
          Common.loader('show');
          this.isDeleteFlag = true;
          const getDocumentList: IDocument = {};
          getDocumentList.agreementId = null;
          getDocumentList.deliverableId = null;
          getDocumentList.deliverableDetailId = dataItem.id;
          getDocumentList.agreementPriorApprovalId = null;
          getDocumentList.financialInformationId = null;
          getDocumentList.agreementNoteId = null;
          getDocumentList.isAllDocument = false;
          this.commonService.getDocument(getDocumentList).subscribe(async (response) => {
            if (response.Documents && response.Documents.length > 0) {
              this.uploadFileList = response.Documents;
              this.uploadFileList.forEach(async (doc: any) => {
                this.commonService.deleteDocumnetFile(JSON.stringify(doc.documentURI)).subscribe(async (respos: any) => {
                  if (respos) {
                    this.deleteDocuments.push(doc.id);
                    await this.commonService.deleteDocument(JSON.stringify(this.deleteDocuments)).subscribe(async (resp: any) => {
                      if (resp) {
                        const index = this.deliverableDetailList.findIndex(({ id }) => id === dataItem.id);
                        if (index !== -1) {
                          this.deleteDeliverableDetailIds.push(dataItem.id);
                          this.deliverableDetailList.splice(index, 1);
                          this.deleteDeliverableDetails();
                        }
                      }
                    });
                  }
                });
              });
            } else {
              const index = this.deliverableDetailList.findIndex(({ id }) => id === dataItem.id);
              this.deliverableDetailList.splice(index, 1);
              this.deleteDeliverableDetailIds.push(dataItem.id);
              this.deleteDeliverableDetails();
            }
          });
        }
      }
    });
  }

  private closeDetailEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
  }
  // Deliverable Detail grid end

  // To delete deliverableDetail
  public deleteDeliverableDetails() {
    if (this.deleteDeliverableDetailIds.length > 0) {
      this.deliverablesService.deleteDeliverableDetails(JSON.stringify(this.deleteDeliverableDetailIds)).subscribe((response: any) => {
        if (response) {
          if (this.isDeleteFlag === true) {
            Common.loader('hide');
            this.notificationService.show({
              content: 'This has been deleted.',
              position: { horizontal: 'center', vertical: 'bottom' },
              animation: { type: 'fade', duration: 500 },
              type: { style: 'success', icon: true },
              hideAfter: 1000,
            });
          }
        }
      });
    }
  }

  // Validation for isEmpty
  isEmpty(paramValue: any): boolean {
    return (paramValue === null || paramValue === undefined || paramValue === '');
  }

  public validateDeliverableSave(formGroup): boolean {
    this.inValidDeliverableType = true;
    if (!(this.isEmpty(formGroup.controls.deliverableType.value))) {
      this.inValidDeliverableType = false;
    }
    this.validContactSave = this.inValidDeliverableType === false ? true : false;
    return this.validContactSave;
  }

  public validateDeliverableDetailsSave(formGroup): boolean {
    this.inValidDeliverableDetail = true;
    if (!(this.isEmpty(formGroup.controls.deliverablePeriod.value))) {
      this.inValidDeliverableDetail = false;
    }
    this.validDetailsSave = this.inValidDeliverableDetail === false ? true : false;
    return this.validDetailsSave;
  }

  // To save deliverables
  saveDeliverables() {
    if (this.deliverableList.length > 0) {
      this.deliverablesService.postDeliverableInformation(JSON.stringify(this.deliverableList)).subscribe((res: any) => {
        if (res) {
          this.getDeliverablesInformation();
          // this.getDocumentDetails(this.deliverableId);
        }
      });
    }
  }

  // To save deliverable details
  saveDeliverableDetails() {
    if (this.deliverableDetailList.length > 0) {
      this.deliverableDetailList.forEach((element: any) => {
        element.dueDate = element.dueDate ? CommonUtil.localToUTC(element.dueDate) : null;
        element.completedDate = element.completedDate ? CommonUtil.localToUTC(element.completedDate) : null;
      });
      this.deliverablesService.postDeliverableDetails(JSON.stringify(this.deliverableDetailList)).subscribe((res: any) => {
        if (res) {
          this.getDeliverableDetails(this.deliverableId);
        }
      });
    }
  }

  getDeliverableDetails(deliverableId: string) {
    this.deliverableDetailList = [];
    this.deliverablesService.getDeliverablesDetail(deliverableId).subscribe((response) => {
      if (response !== undefined && response.DeliverableDetails.length > 0) {
        response.DeliverableDetails.forEach(res => {
          this.deliverableList.forEach(ele => {
            if (ele.id === res.deliverableId) {
              res.dueDate = res.dueDate ? CommonUtil.UTCToLocal(res.dueDate) : null;
              res.completedDate = res.completedDate ? CommonUtil.UTCToLocal(res.completedDate) : null;
              this.deliverableDetailList.push(res);
              ele.detailList = this.deliverableDetailList;
            }
          });
        });
        this.getDocumentDetails(this.deliverableDetailId);
      }
    });
  }

  // To delete the Deliverables
  deleteDeliverables() {
    if (this.deleteDeliverableIds.length > 0) {
      this.deliverablesService.deleteDeliverableInformation(JSON.stringify(this.deleteDeliverableIds)).subscribe((response: any) => {
        if (response) {
          this.routeAfterChange();
        }
        Common.loader('hide');
      });
    }
  }

  deliverableDetailExpanded(event: DetailExpandEvent) {
    this.deliverableDetailList = [];
    if (event.dataItem.id) {
      Common.loader('show');
      this.deliverableId = event.dataItem.id;
      this.deliverablesService.getDeliverablesDetail(this.deliverableId).subscribe((response) => {
        if (response !== undefined && response.DeliverableDetails.length > 0) {
          response.DeliverableDetails.forEach(res => {
            this.deliverableList.forEach(ele => {
              if (ele.id === res.deliverableId) {
                res.dueDate = res.dueDate ? CommonUtil.UTCToLocal(res.dueDate) : null;
                res.completedDate = res.completedDate ? CommonUtil.UTCToLocal(res.completedDate) : null;
                this.deliverableDetailList.push(res);
                this.deliverableDetailList.forEach(el => {
                  el.agreementYear = event.dataItem.agreementYear;
                });
                ele.detailList = this.deliverableDetailList;
                this.deliverablePeriodName = distinctDelPeriodName(this.deliverableDetailList
                  .filter((x) => x.deliverablePeriodName !== ''));
                this.deliverableDesc = distinctDelDescName(this.deliverableDetailList.filter((x) => x.description !== ''));
              }
            });
          });
        }
        Common.loader('hide');
      });
    }
  }

  deliverableDocumentExpanded(event: DetailExpandEvent) {
    this.closeDetailEditor(this.deliverableDetailGrid, -1);
    const getDocumentList: IDocument = {};
    this.uploadFileList = [];
    if (event.dataItem) {
      Common.loader('show');
      this.deliverableDetailId = event.dataItem.id;
      if (this.deliverableDetailId) {
        getDocumentList.agreementId = null;
        getDocumentList.deliverableId = null;
        getDocumentList.deliverableDetailId = this.deliverableDetailId;
        getDocumentList.agreementPriorApprovalId = null;
        getDocumentList.financialInformationId = null;
        getDocumentList.agreementNoteId = null;
        getDocumentList.isAllDocument = false;
        this.commonService.getDocument(getDocumentList).subscribe((response) => {
          if (response !== undefined && response.Documents.length > 0) {
            response.Documents.forEach(res => {
              this.deliverableList.forEach(ele => {
                if (ele.detailList) {
                  ele.detailList.forEach(elem => {
                    if (elem.id === res.deliverableDetailId) {
                      this.uploadFileList.push(res);
                      this.uploadFileList.forEach((el) => {
                        el.deliverablePeriodName = elem.deliverablePeriodName;
                        el.deliverablePeriodValue = elem.deliverablePeriodValue;
                      });
                      elem.uploadFileList = this.uploadFileList;
                    }
                  });
                }
              });
            });
          }
          Common.loader('hide');
        });
      } else {
        Common.loader('hide');
      }
    }
  }

  // Deliverable Documents
  getDeliverablePeriodValue(data: any) {
    this.deliverablesService.getDeliverablePeriodValue(data).subscribe((resp: any) => {
      if (resp) {
        this.deliverablePeriodValueList = resp;
      }
    });
  }

  documentTypeChange(data: any) {
    if (data) {
      this.disabledSelectFileButton = true;
    }
  }

  // deliverablePeriod(periodId: any) {
  //   this.deliverablesService.getDeliverablePeriodValue(periodId).subscribe((resp: any) => {
  //     this.deliverablePeriodValueList = resp;
  //   });
  // }

  public addDocument() {
    // if (this.validateDocumentSave()) {
    this.dialogRef.close(this.documentFormGroup.value);
    this.saveDocuments();
    // }
  }

  // To validate form
  // validateDocumentSave() {
  //   if (this.documentFormGroup.controls.documentType.value) {
  //     this.isDocumentTypeSelected = true;
  //   } else {
  //     this.isDocumentTypeSelected = false;
  //   }
  //   if (!(this.uploadFile === '') || this.validateFile === false) {
  //     this.isDocumentSelected = true;
  //   } else {
  //     this.isDocumentSelected = false;
  //   }
  //   this.isValidForm = (this.isDocumentTypeSelected === true && this.isDocumentSelected === true) ? true : false;
  //   return this.isValidForm;
  // }

  // To save documents
  public saveDocuments() {
    if (this.newUploadFileList.length > 0) {
      this.newUploadFileList.forEach((element: any) => {
        element.agreementId = this.agreementId;
      });
      this.commonService.saveDocument(JSON.stringify(this.newUploadFileList)).subscribe((response: any) => {
        if (response) {
          this.isEnableDocumentDialug = false;
          this.notificationService.show({
            content: 'Document saved successfully.',
            position: { horizontal: 'center', vertical: 'bottom' },
            animation: { type: 'fade', duration: 500 },
            type: { style: 'success', icon: true },
            hideAfter: 1000,
          });
          this.getDocumentDetails(this.deliverableDetailId);
        }
      });
    }
  }

  resetValidation() {
    this.isDocumentTypeSelected = true;
    this.isDocumentSelected = true;
    this.enableAwardYear = false;
    this.validateFile = false;
  }

  public openUploadDocumentDialog(template: TemplateRef<any>, dataItem: any, childGrid) {
    this.deliverablePeriodList.forEach((item, idx) => {
      childGrid.collapseRow(idx);
    });
    this.deliverableDetailId = dataItem.id;
    this.getDeliverableDetails(dataItem.deliverableId);
    this.agreementYear = dataItem.agreementYear ? dataItem.agreementYear : null;
    this.deliverablePeriod = dataItem.deliverablePeriodName ? dataItem.deliverablePeriodName : null;
    this.deliverablePeriodvalue = dataItem.deliverablePeriodValue ? dataItem.deliverablePeriodValue : null;
    this.isExistingDocumentName = false;
    this.disabledSelectFileButton = false;
    this.documentFormGroup.reset();
    this.newUploadFileList = [];
    this.resetValidation();
    this.isEditDocumentDialug = false;
    this.isEnableDocumentDialug = true;
    this.dialogRef = this.dialogService.open({
      title: 'Documents',
      content: template,
      width: 400,
    });
    this.dialogRef.result.subscribe((rs: any) => {
      if (rs instanceof DialogCloseResult) {
        this.isEnableDocumentDialug = false;
        return;
      }
      const newDocument: IDocument = {};
      newDocument.id = this.defaultGuid;
      newDocument.deliverableDetailId = dataItem.id ? dataItem.id : null;
      newDocument.documentTypeId = null;
      newDocument.agreementYear = this.agreementYear;
      newDocument.documentName = this.fileName;
      newDocument.displayFileName = this.fileName;
      newDocument.spDocumentName = this.SpDocumentName;
      newDocument.documentURI = this.documentUri;
      newDocument.fileExtensionTypeId = 1;
      newDocument.isActive = true;
      newDocument.agreementPriorApprovalId = null;
      newDocument.agreementNoteId = null;
      newDocument.financialInformationId = null;
      newDocument.deliverableId = null;
      this.newUploadFileList.push(newDocument);
      this.fileName = '';
      this.documentUri = '';
    }
    );
  }

  public editDocument(template: TemplateRef<any>, dataItem: any, rowIndex: any) {
    this.documentFormGroup.reset();
    this.newUploadFileList = [];
    this.deliverableDetailId = dataItem.deliverableDetailId;
    this.agreementYear = dataItem.agreementYear ? dataItem.agreementYear : null;
    this.deliverablePeriod = dataItem.deliverablePeriodName ? dataItem.deliverablePeriodName : null;
    this.deliverablePeriodvalue = dataItem.deliverablePeriodValue ? dataItem.deliverablePeriodValue : null;
    this.isExistingDocumentName = false;
    this.disabledSelectFileButton = true;
    this.isEnableDocumentDialug = true;
    this.fileExtension = '';
    this.isEditDocumentDialug = true;
    if (dataItem.documentName) {
      this.orgFileName = dataItem.documentName.split('.');
      this.fileExtension = dataItem.documentName.substr(dataItem.documentName.lastIndexOf('.') + 1);
    }
    // this.getDocumentDetails(this.deliverableDetailId);
    this.resetValidation();
    this.disabledUploadButton = true;
    this.documentFormGroup.patchValue({
      displayFileName: this.orgFileName[0],
    });
    this.dialogRef = this.dialogService.open({
      title: ' ',
      content: template,
      width: 400,
    });
    this.dialogRef.result.subscribe((rs: any) => {
      if (rs instanceof DialogCloseResult) {
        this.isEnableDocumentDialug = false;
        return;
      }
      if (!this.isExistingDocumentName) {
        const currentRecord = this.uploadFileList[rowIndex];
        if (this.fileName.trim() && this.fileName !== currentRecord.documentName) {
          this.commonService.deleteDocumnetFile(JSON.stringify(dataItem.documentURI)).subscribe();
        }
        currentRecord.id = dataItem.id;
        currentRecord.agreementId = this.agreementId ? this.agreementId : this.defaultGuid;
        currentRecord.deliverableDetailId = dataItem.deliverableDetailId ? dataItem.deliverableDetailId : null;
        const name = rs.displayFileName + '.' + this.fileExtension;
        currentRecord.displayFileName = name;
        currentRecord.spDocumentName = dataItem.spDocumentName;
        currentRecord.deliverableId = null;
        currentRecord.documentTypeId = null;
        currentRecord.agreementYear = this.agreementYear;
        currentRecord.documentName = name ? name : rs.displayFileName;
        currentRecord.documentURI = this.documentUri ? this.documentUri : currentRecord.documentURI;
        currentRecord.fileExtensionTypeId = 1;
        currentRecord.isActive = true;
        currentRecord.agreementPriorApprovalId = null;
        currentRecord.agreementNoteId = null;
        currentRecord.financialInformationId = null;
        this.newUploadFileList.push(currentRecord);
      }
    });
    this.fileName = '';
    this.documentUri = '';
  }

  public deleteDocument(dataItem: any, rowIndex: number, childGrid) {
    this.selectedDataItem = dataItem;
    this.selectedRowIndex = rowIndex;
    if (this.selectedDataItem.documentURI !== null) {
      this.dialogRef = this.dialogService.open({
        title: 'Please Confirm',
        content: 'Are you sure, do you want to delete it?',
        actions: [
          { text: 'Yes', primary: true },
          { text: 'No' }],
        width: 400,
      });
      this.dialogRef.result.subscribe((rs: any) => {
        if (rs.text && rs.text === 'Yes') {
          if (this.selectedDataItem.id) {
            Common.loader('show');
            this.deleteDocuments.push(this.selectedDataItem.id);
            this.commonService.deleteDocumnetFile(JSON.stringify(this.selectedDataItem.documentURI)).subscribe((res: any) => {
              if (res) {
                this.commonService.deleteDocument(JSON.stringify(this.deleteDocuments)).subscribe((response: any) => {
                  if (response) {
                    this.deliverableDetailList.forEach(ele => {
                      if (ele.id === this.selectedDataItem.deliverableDetailId) {
                        if (ele.uploadFileList.length > 0) {
                          const index = ele.uploadFileList.findIndex(x => x.id === this.selectedDataItem.id);
                          ele.uploadFileList.splice(index, 1);
                        }
                      }
                    });
                    this.notificationService.show({
                      content: 'This has been deleted.',
                      position: { horizontal: 'center', vertical: 'bottom' },
                      animation: { type: 'fade', duration: 500 },
                      type: { style: 'success', icon: true },
                      hideAfter: 1000,
                    });
                    this.deliverablePeriodList.forEach((item, idx) => {
                      childGrid.collapseRow(idx);
                    });
                    Common.loader('hide');
                  }
                });
              }
            });
            this.uploadFileList.splice(this.selectedRowIndex, 1);
          } else {
            this.uploadFileList.splice(this.selectedRowIndex, 1);
          }
        }
      });
    } else {
      this.dialogRef = this.dialogService.open({
        title: 'Information',
        content: 'Document does not exist',
        actions: [
          { text: 'Ok', primary: true }
        ],
        width: 400,
      });
    }
  }

  public downloadDocument(dataItem: any) {
    if (dataItem.documentURI) {
      Common.loader('show');
      this.commonService.downloadDocument(dataItem.documentURI)
        .subscribe((data) => {
          const anchor = document.createElement('a');
          anchor.download = dataItem.documentName;
          const ext = dataItem.documentURI.substr(dataItem.documentURI.lastIndexOf('.') + 1);
          const blob = this.base64ToBlob(data);
          anchor.href = URL.createObjectURL(blob);
          anchor.dataset.downloadurl = [this.mimeMapping.get(ext), anchor.download, anchor.href].join(':');
          anchor.click();
          Common.loader('hide');
        });
    } else {
      this.dialogRef = this.dialogService.open({
        title: 'Information',
        content: 'Document does not exist',
        actions: [
          { text: 'Ok', primary: true }
        ],
        width: 400,
      });
    }
  }

  public base64ToBlob(b64Data, contentType = '', sliceSize = 512) {
    b64Data = b64Data.replace(/\s/g, ''); // IE compatibility...
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: 'application/octet-stream' });
  }

  resetPreview() {
    this.url = '';
    this.data = '';
    this.headData = '';
    this.isEnablePDF = false;
    this.isEnableXLXS = false;
    this.isEnableJPG = false;
    this.isEnableTXT = false;
    this.isEnablemsg = false;
    this.isEnableDOCX = false;
  }

  enablePreviewDialog(template: TemplateRef<any>, dataItem: any) {
    if (dataItem.documentURI) {
      this.resetPreview();
      this.enablePreviewDataItem = dataItem;
      const extension = dataItem.documentURI.substr(dataItem.documentURI.lastIndexOf('.') + 1);
      this.dialogPreviewRef = this.dialogService.open({
        title: 'Preview',
        content: template,
        width: 800,
        height: 600,
      });
      Common.loader('show');
      if (extension === 'docx' || extension === 'msg' || extension === 'doc' || extension === 'zip' || extension === 'html') {
        this.isEnableDOCX = true;
        this.documentURI = dataItem.documentURI;
        Common.loader('hide');
      } else {
        this.commonService.downloadDocument(dataItem.documentURI)
          .subscribe((data) => {
            this.documentURI = dataItem.documentURI;
            const blob = this.previewBlob(data, extension);
            if (extension === 'txt') {
              this.isEnableTXT = true;
              const fileReader = new FileReader();
              fileReader.onload = (e) => {
                this.url = e.target.result;
              };
              fileReader.readAsText(blob);
            } else if (extension === 'xlsx' || extension === 'xls' || extension === 'csv') {
              this.isEnableXLXS = true;
              const target = blob;
              const reader: FileReader = new FileReader();
              reader.onload = (e: any) => {
                /* read workbook */
                const bstr: string = e.target.result;
                const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
                /* grab first sheet */
                const wsname: string = wb.SheetNames[0];
                const ws: XLSX.WorkSheet = wb.Sheets[wsname];
                /* save data */
                this.data = ((XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, range: 0 })) as AOA);
                this.headData = this.data[0];
                this.data = this.data.slice(1); // remove first header record
                const ws2: XLSX.WorkSheet = wb.Sheets[wb.SheetNames[1]];
                this.readDataSheet(ws2, 1);
              };
              reader.readAsBinaryString(target);
            } else if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
              this.isEnableJPG = true;
              const reader = new FileReader();
              reader.onload = (ev) => {
                this.url = ev.target.result;
              };
              reader.readAsDataURL(blob);
            } else if (extension === 'pdf') {
              this.isEnablePDF = true;
              const reader = new FileReader();
              reader.readAsDataURL(blob);
              reader.onload = (ev) => {
                this.url = ev.target.result;
              };
            }
            Common.loader('hide');
          });
      }
    }
  }

  private readDataSheet(ws: XLSX.WorkSheet, startRow: number) {
    /* save data */
    let datas = (XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, range: startRow })) as AOA;
    const headDatas = datas[0];
    datas = datas.slice(1); // remove first header record
    for (let i = 0; i < this.data.length; i++) {
      this.data[i][this.headData.length] = datas.filter(x => x[12] === this.data[i][0]);
    }
  }

  public previewBlob(b64Data, ext: any, contentType = '', sliceSize = 512) {
    let tempdata: any;
    b64Data = b64Data.replace(/\s/g, ''); // IE compatibility...
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    if (ext === 'png') {
      tempdata = new Blob(byteArrays, { type: 'image/png' });
    } else if (ext === 'jpg') {
      tempdata = new Blob(byteArrays, { type: 'image/jpg' });
    } else if (ext === 'jpeg') {
      tempdata = new Blob(byteArrays, { type: 'image/jpeg' });
    } else if (ext === 'pdf') {
      tempdata = new Blob(byteArrays, { type: 'application/pdf' });
    } else if (ext === 'ppt') {
      tempdata = new Blob(byteArrays, { type: 'application/vnd.ms-powerpoint' });
    } else if (ext === 'pptx') {
      tempdata = new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
    } else if (ext === 'rtf') {
      tempdata = new Blob(byteArrays, { type: 'application/rtf' });
    } else {
      tempdata = new Blob(byteArrays, { type: 'application/octet-stream' });
    }
    return tempdata;
  }

  public selectEventHandler(event: SelectEvent) {
    if (event.files && event.files.length > 0) {
      if (!event.files[0].validationErrors) {
        this.uploadFile = event.files[0].rawFile;
        this.isDocumentSelected = true;
        this.onFileSelected(event);
      } else {
        this.uploadFile = this.defaultGuid;
        this.isDocumentSelected = false;
        this.isExistingDocumentName = false;
      }
    }
  }

  onFileSelected(event) {
    const file: File = event.files[0].rawFile;
    const attachment: any = {};
    if (file) {
      Common.loader('show');
      this.disabledUploadButton = false;
      const validateDocumentName = this.uploadFileList.find((ele) => ele.spDocumentName === file.name);
      if (validateDocumentName) {
        this.isExistingDocumentName = true;
        this.selectedDataItem = validateDocumentName;
        Common.loader('hide');
      } else {
        this.fileName = file.name;
        attachment.agreementId = this.agreementId ? this.agreementId : this.defaultGuid;
        attachment.agreementName = this.awardTitle;
        attachment.awardNumber = this.awardNumber;
        attachment.nickName = this.awardNickName;
        attachment.moduleName = this.moduleName;
        attachment.agreementYear = this.agreementYear;
        attachment.documentType = null;
        attachment.SubModuleName = this.deliverablePeriod;
        attachment.deliverableperiod = this.deliverablePeriod;
        attachment.deliverableperiodvalue = this.deliverablePeriodvalue;
        if (file) {
          this.orgFileName = file.name.split('.');
          this.documentFormGroup.patchValue({ displayFileName: this.orgFileName[0] });
          this.fileExtension = this.orgFileName[1];
        }
        this.commonService.uploadAttachment(attachment, file).subscribe((res: any) => {
          if (res) {
            Common.loader('hide');
            this.documentUri = res;
            const fileName = this.documentUri.substr(this.documentUri.lastIndexOf('/') + 1, this.documentUri.length);
            this.SpDocumentName = fileName.split('.')[0];
            this.disabledUploadButton = true;
          }
        });
      }
    }
  }

  async getFileBuffer(file: File): Promise<ArrayBuffer> {
    const buffer = await new Response(file).arrayBuffer();
    return buffer;
  }

  public clearEventHandler(event: ClearEvent) {
    this.uploadFile = this.defaultGuid;
  }

  public removeEventHandler(event: RemoveEvent) {
    this.uploadFile = this.defaultGuid;
  }

  public overrideYes(data: any) {
    if (data === 'Yes') {
      Common.loader('show');
      if (this.selectedDataItem.id) {
        if (this.selectedDataItem.documentURI) {
          // to delete the existing file.
          this.commonService.deleteDocumnetFile(JSON.stringify(this.selectedDataItem.documentURI)).subscribe();
        }
        // to upload document
        const attachment: any = {};
        this.fileName = this.uploadFile.name;
        attachment.agreementId = this.agreementId ? this.agreementId : this.defaultGuid;
        attachment.agreementName = this.awardTitle;
        attachment.awardNumber = this.awardNumber;
        attachment.nickName = this.awardNickName;
        attachment.agreementYear = this.agreementYear;
        attachment.documentType = null;
        attachment.moduleName = this.moduleName;
        attachment.SubModuleName = this.deliverablePeriod;
        attachment.deliverableperiod = this.deliverablePeriod;
        attachment.deliverableperiodvalue = this.deliverablePeriodvalue;
        this.commonService.uploadAttachment(attachment, this.uploadFile).subscribe((res: any) => {
          if (res) {
            this.documentUri = res;
            const fileList: IDocument[] = [];
            this.selectedDataItem.documentURI = this.documentUri;
            this.selectedDataItem.displayFileName = this.documentFormGroup.controls.displayFileName.value;
            this.selectedDataItem.deliverablePeriodValueId = this.deliverablePeriodvalue;
            if (this.deliverablePeriod === 'Quarterly') {
              this.selectedDataItem.deliverablePeriodId = 1;
            } else if (this.deliverablePeriod === 'Semi Annually') {
              this.selectedDataItem.deliverablePeriodId = 2;
            } else if (this.deliverablePeriod === 'Annually') {
              this.selectedDataItem.deliverablePeriodId = 3;
            }
            fileList.push(this.selectedDataItem);
            // to save the agreement document.
            this.commonService.saveDocument(JSON.stringify(fileList)).subscribe((response: any) => {
              if (response) {
                this.getDocumentDetails(this.deliverableDetailId);
                this.dialogRef.close(this.documentFormGroup.value);
                Common.loader('hide');
              }
            });
          }
        });
      }
    }
    else {
      this.dialogRef.close();
    }
  }

  public show(): void {
    if (this.saveFlag) {
      this.notificationService.show({
        content: 'This has been saved.',
        position: { horizontal: 'center', vertical: 'bottom' },
        animation: { type: 'fade', duration: 500 },
        type: { style: 'success', icon: true },
        hideAfter: 1000,
      });
    }
  }

  autoSave() {
    this.intervaltime = setInterval(() => {
      if (this.isEnableDocumentDialug === false) {
        if (this.deliverableEntryForm.touched) {
          const element: HTMLElement = document.getElementById('submitBtn') as HTMLElement;
          element.click();
          $('.deliverableSave').click();
        }
      }
    }, +environment.autoSave);
  }

  // grid column filter
  public categoryFilters(filter: CompositeFilterDescriptor): FilterDescriptor[] {
    this.categoryFilter.splice(
      0, this.categoryFilter.length,
      ...flatten(filter).map(({ value }) => value)
    );
    return this.categoryFilter;
  }

  public titleValueChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'title',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public delPeriodNameValueChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'deliverablePeriodName',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public delDescNameValueChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'description',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public agreementYearValueChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'agreementYear',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public deliverableTypeValueChange(values: any[], filterService: FilterService): void {
    filterService.filter({
      filters: values.map(value => ({
        field: 'typeName',
        operator: 'eq',
        value
      })),
      logic: 'or'
    });
  }

  public handleDeliverableType(value: any) {
    if (value.length >= 1) {
      this.deliverableTypeList = this.deliverableTypeOriginalList.filter((s) =>
        s.typeName.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    } else {
      this.deliverableTypeList = this.deliverableTypeOriginalList;
    }
  }

  public handleNotification(value: any) {
    if (value.length >= 1) {
      this.notificationList = this.notificationOriginalList.filter((s) =>
        s.frequencyName.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    } else {
      this.notificationList = this.notificationOriginalList;
    }
  }

  ngOnDestroy() {
    if (this.intervaltime) {
      clearInterval(this.intervaltime);
    }
  }
}
